import { render, staticRenderFns } from "./my_honour.vue?vue&type=template&id=47eea5a7"
import script from "./my_honour.vue?vue&type=script&lang=js"
export * from "./my_honour.vue?vue&type=script&lang=js"
import style0 from "./my_honour.vue?vue&type=style&index=0&id=47eea5a7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports